@if (loading()) {
    <app-loader [isLoading]="loading()"/>
}
<mat-dialog-content>
    <h4 mat-card-title>Резюме по заявке</h4>
    <div class="flex-column">
        <span class="title">Заявка:
            <span class="subtitle">{{this.order.data.id}}</span>
        </span>
        <span class="title f-bold">Работы:</span>
        @for (work of works; track $index) {
            <span class="subtitle">{{work}}</span>
        }
        <span class="title">Сумма к оплате:
            <span class="subtitle">{{totalPrice}}</span>
        </span>
        <span class="title">Передоплата:
            <span class="subtitle">{{this.order.data.prepayment || 0}}</span>
        </span>
        @if (this.order.data.discount) {
            <span class="flex title">Скидка:
                <mat-icon class="discount-icon success">check</mat-icon>
            </span>
        }
    </div>
    @if (enablePaymentDevice) {
        <button class="w-100 mrt-1" mat-raised-button type="button" (click)="sendToPaymentDevice()">Отправить на кассу</button>
    }
    <div class="flex a-center justify-between mrt-1">
        <button mat-stroked-button color="accent" type="button" (click)="onCancel()">Отмена</button >
        <button mat-flat-button color="primary" (click)="onAccept()">Подтвердить</button >
    </div>
</mat-dialog-content>
